import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import { useAuth } from '../../contexts/auth/AuthContext';
import { format } from 'date-fns';
import { ConversationSummary, getAllConversations } from '../../lib/services/messageService';

// Notification sound (base64 encoded short beep)
const NOTIFICATION_SOUND = 'data:audio/wav;base64,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';

const MessageNotificationBell: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [conversations, setConversations] = useState<ConversationSummary[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const prevCountRef = useRef<number>(0);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  // Only show for admin and crew
  const isStaff = userProfile?.role === 'admin' || userProfile?.role === 'crew';

  // Initialize audio element
  useEffect(() => {
    audioRef.current = new Audio(NOTIFICATION_SOUND);
    audioRef.current.volume = 0.5;
  }, []);

  // Play notification sound
  const playNotificationSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {
        // Ignore autoplay errors (browser may block until user interaction)
      });
    }
  }, []);

  // Fetch conversations needing attention (last message from customer)
  const fetchConversations = useCallback(async (playSound: boolean = false) => {
    const data = await getAllConversations('open');

    // Filter to only show conversations where last message is from customer (needs reply)
    const needsAttention = data.filter(conv => {
      // If no messages, it's a new conversation - needs attention
      if (!conv.last_message) return true;
      // If last_message_sender_type is available, use it
      if (conv.last_message_sender_type) {
        return conv.last_message_sender_type === 'customer';
      }
      // Fallback: consider all open conversations as needing attention
      return true;
    });

    setConversations(data.slice(0, 5)); // Show all open in dropdown

    // Count conversations needing attention (last message from customer)
    const newCount = needsAttention.length;

    // Play sound if count increased (new message from customer)
    if (playSound && newCount > prevCountRef.current) {
      playNotificationSound();
    }

    prevCountRef.current = newCount;
    setUnreadCount(newCount);
  }, [playNotificationSound]);

  useEffect(() => {
    if (isStaff) {
      fetchConversations(false); // Don't play sound on initial load
    }
  }, [isStaff, fetchConversations]);

  // Subscribe to new messages
  useEffect(() => {
    if (!isStaff) return;

    const channel = supabase
      .channel('staff-message-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages'
        },
        (payload) => {
          // Only play sound for customer messages, not staff's own messages
          const isCustomerMessage = payload.new.sender_type === 'customer';
          fetchConversations(isCustomerMessage);
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'messages'
        },
        () => {
          fetchConversations(false);
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations'
        },
        () => {
          fetchConversations(false);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [isStaff, fetchConversations]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle conversation click
  const handleConversationClick = (conv: ConversationSummary) => {
    const basePath = userProfile?.role === 'admin' ? '/admin/messages' : '/crew/messages';
    navigate(basePath);
    setIsOpen(false);
  };

  // Handle view all click
  const handleViewAll = () => {
    const basePath = userProfile?.role === 'admin' ? '/admin/messages' : '/crew/messages';
    navigate(basePath);
    setIsOpen(false);
  };

  if (!isStaff) return null;

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Chat icon with notification counter */}
      <button
        className="relative p-2 text-gray-700 hover:text-[#3A5E63] focus:outline-none bg-gray-100 rounded-full"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Messages"
      >
        <span className="text-xl">💬</span>
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-amber-500 rounded-full animate-pulse">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg overflow-hidden z-50">
          <div className="p-3 bg-amber-50 border-b flex justify-between items-center">
            <h3 className="font-medium text-amber-800">Customer Messages</h3>
            {unreadCount > 0 && (
              <span className="text-xs text-amber-600 font-medium">
                {unreadCount} open
              </span>
            )}
          </div>

          <div className="max-h-80 overflow-y-auto">
            {conversations.length === 0 ? (
              <div className="p-4 text-center text-gray-500">
                No open conversations
              </div>
            ) : (
              <div>
                {conversations.map((conv) => (
                  <div
                    key={conv.id}
                    className="p-3 border-b hover:bg-amber-50 cursor-pointer"
                    onClick={() => handleConversationClick(conv)}
                  >
                    <div className="flex items-start">
                      <div className="mt-1 mr-3 flex-shrink-0 text-amber-500">
                        💬
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-medium text-sm truncate">
                          {conv.customer_name || conv.guest_email || 'Unknown'}
                        </div>
                        <div className="text-sm text-gray-600 truncate">
                          {conv.last_message || 'No messages yet'}
                        </div>
                        <div className="text-xs text-gray-500 mt-1">
                          {conv.last_message_at
                            ? format(new Date(conv.last_message_at), 'MMM d, h:mm a')
                            : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* View all link */}
          <div className="p-2 bg-gray-50 border-t">
            <button
              onClick={handleViewAll}
              className="w-full text-center text-sm text-[#3A5E63] hover:text-[#2c474b] font-medium py-1"
            >
              View all messages →
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageNotificationBell;
